query CampaignSections($clientId: ID!, $wppProjectId: String) {
    campaignSections(clientId: $clientId, wppProjectId: $wppProjectId) {
        _id
        name
    }
}
